import useUserNavigationUtils from "@hooks/useUserNavigationUtils"

import { faIcon } from "@utils/faIcon"

import SideBarItem from "@organisms/SideBar/components/SideBarItem/SideBarItem"

export default function WhatsNew() {
    const { openChangelog } = useUserNavigationUtils()

    return (
        <SideBarItem
            onClick={() => openChangelog()}
            label="What's New"
            icon={faIcon({ name: "bullhorn", style: "regular" })}
            iconActive={faIcon({ name: "bullhorn", style: "solid" })}
        />
    )
}
